import { apiFileTemporaryUrl } from '@api/common';

const useFileNameToUrl = async fileName => {
  if (!fileName) return;
  const url = await apiFileTemporaryUrl({ filename: fileName });
  return url.data;
};
export default useFileNameToUrl;
